import { motion } from "framer-motion";
import { JOURNEY } from "@/lib/content";
import { fadeUp, stagger } from "@/lib/motion";

export default function Journey() {
  return (
    <section
      id="journey"
      data-testid="journey-section"
      className="relative bg-ink-950 py-28 md:py-40 border-t border-ivory/[0.06]"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-12">
          <div className="col-span-12 md:col-span-4 md:sticky md:top-28 self-start">
            <div className="font-mono-caps text-[10px] text-copper mb-6">
              <span className="mr-3">§ 02</span> Manifesto · Journey
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ivory">
              Eight chapters,<br />
              <span className="italic text-copper">one practice.</span>
            </h2>
            <p className="mt-8 text-ivory/60 max-w-sm font-light leading-relaxed">
              A non-linear route from interior design to architecture to development —
              each chapter compounding into the next.
            </p>
          </div>

          <motion.ol
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
            variants={stagger}
            className="col-span-12 md:col-span-8 relative"
          >
            {/* Timeline rail */}
            <div className="absolute left-0 md:left-6 top-0 bottom-0 w-px bg-ivory/[0.08]" />

            {JOURNEY.map((c) => (
              <motion.li
                key={c.no}
                variants={fadeUp}
                className="relative pl-8 md:pl-24 py-8 md:py-10 border-b border-ivory/[0.06] group"
                data-testid={`journey-chapter-${c.no}`}
              >
                {/* Dot on rail */}
                <span className="absolute left-[-3px] md:left-[21px] top-12 h-1.5 w-1.5 bg-copper rounded-full ring-4 ring-ink-950" />
                <div className="flex items-baseline gap-6 flex-wrap">
                  <span className="font-mono text-copper text-sm">{c.no}</span>
                  <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl text-ivory font-light leading-tight max-w-[24ch] transition-colors duration-500 group-hover:text-copper">
                    {c.title}
                  </h3>
                </div>
                <p className="mt-3 md:mt-4 text-ivory/55 max-w-xl leading-relaxed">
                  {c.note}
                </p>
              </motion.li>
            ))}
          </motion.ol>
        </div>
      </div>
    </section>
  );
}
